export default __webpack_public_path__ + "static/media/3031 utensils side.466ad34d.png";